import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {  Button,
          Modal,
          Form,
          FormGroup,
          FormControl,
          Col
 } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

//@observer(['categories', 'industries'])
@observer(['categories'])
export default class Categories extends Component {

  constructor(props) {
    super(props)

    this.props.categories.loadAllCategories()
    //this.props.industries.loadAllIndustries()

    this.state = {
      showEditCategoryModal: false,
      editCategoryId: '',
      editCategoryName: ''
    }
  }

  openEditCategoryModal(row) {
    this.setState({
      showEditCategoryModal: true,
      editCategoryId: row.id,
      editCategoryName: row.name
    })

    //this.props.industries.loadAllIndustriesWithCategories(() => {
      //document.getElementById('editId').value = row.id
      //document.getElementById('editIndustryId').value = row.industryId
      //document.getElementById('editName').value = row.name
    // })
  }

  closeEditCategoryModal() {
    this.setState({
      showEditCategoryModal: false
    })
  }

  newCategory(row) {
    this.props.categories.newCategory(row)
  }

  updateCategory(e) {
    let row = {
      id: document.getElementById('editId').value,
      //industryId: document.getElementById('editIndustryId').value,
      industryId: 0, //Industry not needed anymore, setting to zero
      name: document.getElementById('editName').value
    }
    this.props.categories.updateCategory(row)
    this.closeEditCategoryModal()
  }

  deleteCategory(id) {
    if (confirm('Are you sure you want to delete this Category?')) {
      this.props.categories.deleteCategory(id)
    }
  }

  formatActions(cell, row) {
    return (
      <div>
        <Button bsSize="small" bsStyle="warning" id={ cell } onClick={ () => { this.openEditCategoryModal(row) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button>
        <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteCategory(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
      </div>
    )
  }

  editCategoryNameValue(e) {
    this.setState({
      editCategoryName: e.target.value
    })
  }

  render() {
    const options = {
      onAddRow: this.newCategory.bind(this)
    }

    /*
    const ddOptions = this.props.industries.data.map((option) => {
      return option.name
    })

    const industriesDropdown = (
      <FormControl componentClass="select" id="editIndustryId">
      {
        this.props.industries.data.map((ind) => {
          return (
            <option value={ ind.id }>{ ind.name }</option>
          )
        })
      }
      </FormControl>
    )

    const industriesDropdownOld = this.props.industries.data ?
    (
      <FormControl componentClass="select" id="categoryId">
        {
          this.props.industries.data.map((ind) => {
            return (
              <optgroup label={ ind.name }>
              {
                ind.categories ? ind.categories.map((cat) => {
                  return (<option value={ cat.id }>{ cat.name }</option>)
                }) : (<option>LOADING...</option>)
              }
              </optgroup>
            )
          })
        }
      </FormControl>
    ) : (
      <div>Loading...</div>
    )
    */

    const categoriesTable = (
      <BootstrapTable
          data={ this.props.categories.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          //cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateCategory.bind(this) } }
          >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        { /* <TableHeaderColumn width="50" dataField="industryName" editable={{ type: 'select', options: { values: ddOptions } }}>Industry</TableHeaderColumn> */ }
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Industries" content={ categoriesTable } />
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showEditCategoryModal } onHide={ this.closeEditCategoryModal.bind(this) } bsSize="small">
          <Modal.Header closeButton>
            <Modal.Title>Edit Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Form horizontal name="editCategoryForm">
            <input type="hidden" id="editId" value={ this.state.editCategoryId } />
              <FormGroup>
                <Col sm={ 12}><FormControl type="text" placeholder="Name" id="editName" value={ this.state.editCategoryName } onChange={ this.editCategoryNameValue.bind(this) }/></Col>
              </FormGroup>
              { /*
              <FormGroup>
                <Col sm={ 12 }>{ industriesDropdown }</Col>
              </FormGroup>
              */ }
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEditCategoryModal.bind(this) }><i className="fa fa-times" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.updateCategory.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/categories.js